<template>
	<card>
		<div class="CuratorsView mb-4">
			<div class="developerView mb-2 col-sm-12 col-lg-10" v-for="(objCurator,index) in masCuratorList" :key="objCurator.dev_name_tr">
				<div class="dev pr-2"><h5>{{getDevName(objCurator.dev_name_tr)}}</h5></div>
				<div class="curators">
					<ReTagGroupList
						v-model="objCurator.staff_codes"
						name="CuratorListEdit"
						placeholder="Выбор кураторов"
						:objApiMethod="{'obj':'staff' ,'flt':{'fio':'','add_virt_curator':'1'}}"
						:strApiMethodKey="'fio'"
					/>
					<base-button @click="SaveDevCurators(index)" type="success" class="no-border my-0 btn-history" simple icon><i class="d-inline-block tim-icons icon-book-bookmark"></i></base-button>
					<base-button @click="DelDevCurators(index)" type="danger" class="no-border my-0 btn-history" simple icon><i class="d-inline-block tim-icons icon-trash-simple"></i></base-button>
				</div>
			</div>
		</div>
		<div class="addCurators">
			<h4>Добавить кураторов для застройщика</h4>
			<div class="d-flex col-sm-12 col-lg-10">
				<el-select
						class="dev-select select-primary mr-2"
						v-model="objAddCurator.selDev" 
						placeholder="Застройщики"
						size="large"
						filterable
						@change="ResetCurators()"
					>
						<el-option
							class="select-primary"
							v-for="item in masDevSelectOpts"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						>
					</el-option>
				</el-select>

				<ReTagGroupList
					class="w-100"
					v-model="objAddCurator.masCurators"
					name="CuratorList"
					placeholder="Выбор кураторов"
					:objApiMethod="objAddCurator.objApiMethod"
					:strApiMethodKey="objAddCurator.strApiMethodKey"
				/>
			</div>
			<base-button @click="SaveNewCurators()" type="success" simple>Добавить</base-button>
		</div>
	</card>
</template>
<script>

import { Select, Option } from 'element-ui';
import ReTagGroupList from "src/our_components/ReTagGroupList.vue";


export default {
	name: 'Curator_edit-page',
	components: {
		[Option.name]: Option,
		[Select.name]: Select,
		ReTagGroupList,
		//ElPopconfirm,
	},
	data() {
		return {
			masCuratorList: [],
			masAllDev:[],
			masDevSelectOpts:[],
			objAddCurator:{
				selDev:'',
				masCurators:[],
				objApiMethod:{'obj':'staff' ,'flt':{'fio':'','add_virt_curator':'1'}},
				strApiMethodKey:'fio'
			}
		};
	},
	methods: {
		DelDevCurators(iRowIndex){
			const objCuratosRow = this.masCuratorList[iRowIndex];
			this.$GVO.ApiCall('DelDevCurator',{obj:'DEV',flt:{id:objCuratosRow.id}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success === true){
						this.getDev();
					}
				}).catch(errorObjApi => console.error(errorObjApi));
		},
		SaveDevCurators(iRowIndex){
			const objCuratosRow = this.masCuratorList[iRowIndex];
			if(objCuratosRow.staff_codes.length > 0){
				this.$GVO.ApiCall('UpdDevCurator',{obj:'DEV',uData:{dev_name_tr:objCuratosRow.dev_name_tr,staff_codes:objCuratosRow.staff_codes},flt:{id:objCuratosRow.id}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success === true){
						//this.getDev();
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}else{
				this.$GVO.ApiCall('DelDevCurator',{obj:'DEV',flt:{id:objCuratosRow.id}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success === true){
						this.getDev();
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		ResetCurators(){
			this.objAddCurator.masCurators = [];
		},
		SaveNewCurators(){
			//console.log(this.objAddCurator);
			if(this.objAddCurator.selDev != '' && this.objAddCurator.masCurators.length>0){
				this.$GVO.ApiCall('InsDevCurator',{obj:'DEV',iData:{dev_name_tr:this.objAddCurator.selDev,staff_codes:this.objAddCurator.masCurators}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success === true){
						this.ResetCurators();
						this.objAddCurator.selDev = '';
						this.getDev();
					}else{
						this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на редактирование кураторов.</p>')
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		getDev(){
			if(this.masAllDev.length == 0){
				this.$GVO.ApiCall('GET',{obj:'DEV',flt:{list:true}})
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.masAllDev = objApi.data;
							this.getDevCuratorList();
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}else{
				this.getDevCuratorList();
			}
		},
		getDevCuratorList(){
			this.$GVO.ApiCall('GetDevCurator',{obj:'DEV'})
			.then((objApi) => {
				let masDmpDevNamesTr = [];
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.masCuratorList = objApi.data;
						for (let i = 0; i < this.masCuratorList.length; i++) {
							this.masCuratorList[i].staff_codes = this.$GVO.SafeParseJson(this.masCuratorList[i].staff_codes);
							masDmpDevNamesTr.push(this.masCuratorList[i].dev_name_tr);
						}
					}
				}
				this.masDevSelectOpts = [];
				for(let oc=0;oc<this.masAllDev.length;oc++){
					if(masDmpDevNamesTr.indexOf(this.masAllDev[oc].dev_name_tr) == -1){
						this.masDevSelectOpts.push({value: this.masAllDev[oc].dev_name_tr, label: this.masAllDev[oc].dev_name});
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		getDevName(dev_name_tr){
			for (let i = 0; i < this.masAllDev.length; i++) {
				if(this.masAllDev[i].dev_name_tr == dev_name_tr){
					return this.masAllDev[i].dev_name
				}
			}
			return false;
		},
	},
	mounted() {
		this.getDev();
	}
};
</script>
<style>
	.developerView{
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #01B0E0;
    	padding: 5px 5px;
	}
	.curators > *{
		display: inline-block;
	}
	.addCurators > button {
		margin-right: 15px;
    	margin-left: 15px;
	}
	.dev-select{
		min-width: 310px;
	}

/*===media===============================*/
@media (max-width: 686px) {	
	.developerView {flex-wrap: wrap;}
}

	

</style>
